import { RecordType } from '@petconsole/pure-base';
import { groomerApiEntity } from '@petconsole/pure-fe-api';
import { GroomerRecord } from '@petconsole/pure-shared';
import { sliceHookTypes } from '../../../helpers';
import {
  BaseSliceOptions,
  BaseSliceTab,
  CitySearchHooks,
  OurEntityHooks,
  RatingHooks,
  RequiredCrudSliverHooks,
  RequiredSliverHooks,
  TabValueHooks,
} from '../../../types';
import BaseEntitySlice from '../../base/BaseEntitySlice';

type ApiEntityRecord = GroomerRecord;

const apiEntity = groomerApiEntity;
const { name: sliceName, plural } = apiEntity;
const groomer = sliceName;
const groomers = plural;
const groomerAdmin = `${sliceName}Admin`;

const Tab = { groomerAdmin, groomer, groomers } as const;
type Tabs = { [key in keyof typeof Tab]: BaseSliceTab };
type TabHooks = { [key in keyof typeof Tab]: TabValueHooks };
const tabs: Tabs = {
  groomerAdmin: { default: '' },
  groomer: { default: '' },
  groomers: { default: '' },
};

const options: BaseSliceOptions<ApiEntityRecord> = {
  ...apiEntity,
  hasCitySliver: true,
  hasNewestSliver: true,
  hasCitySearch: true,
  hasDefaultProperties: true,
  hasRating: true,
  sortProperty: 'parkName',
  tabs,
};
const { hooks, reducer } = new BaseEntitySlice<ApiEntityRecord>({ options });
const { crudHooks, sliverHooks, propertyHooks, citySearchHooks, ratingHooks, tabHooks } = sliceHookTypes;

export interface OurGroomerHooks<T extends RecordType = ApiEntityRecord> extends OurEntityHooks<T> {
  groomerHooks: RequiredCrudSliverHooks;
  cityGroomerHooks: RequiredSliverHooks;
  newestGroomerHooks: RequiredSliverHooks;
  propertyHooks: RecordType;
  citySearchHooks: CitySearchHooks;
  ratingHooks: RatingHooks;
  tabHooks: TabHooks;
}

export const ourGroomerHooks: OurGroomerHooks = {
  entity: apiEntity,
  groomerHooks: crudHooks(apiEntity, hooks) as RequiredCrudSliverHooks,
  cityGroomerHooks: sliverHooks(apiEntity, 'City', hooks) as RequiredSliverHooks,
  newestGroomerHooks: sliverHooks(apiEntity, 'Newest', hooks) as RequiredSliverHooks,
  citySearchHooks: citySearchHooks(apiEntity, hooks),
  propertyHooks: propertyHooks(apiEntity, hooks),
  ratingHooks: ratingHooks(apiEntity, hooks),
  tabHooks: <TabHooks>tabHooks(Object.keys(Tab), hooks),
};

export default reducer;
